<template>
  <el-dialog
    :visible.sync="disableDialog"
    :width="type===2?'600px':'410px'"
    :title="type===1?'期初应收款划拨':type===2?'回款划拨':'工单划拨'"
  >
    <div style="padding: 0 30px">
      <el-form>
        <el-form-item label="合同编号：" v-if="type===2">{{params.contractCode}}</el-form-item>
        <el-form-item label="划拨金额：">
          <el-input-number
            :controls="false"
            :precision="2"
            style="width:70%"
            :placeholder="`1-${initalBalanceVal.toFixed(2)}`"
            v-model="amount"
            :min="0.01"
            :max="initalBalanceVal"
          ></el-input-number>
        </el-form-item>
      </el-form>
      <div v-if="type===2">已到期账款：{{params.accountsDue|priceFilter}}</div>
      <el-table
        v-if="type===2"
        style="margin:20px 0;"
        :data="params.otherPaymentList"
        :header-cell-style="tableHeader"
        v-loading="loadingTable"
        element-loading-text="拼命加载中请稍后..."
        border
        element-loading-spinner="el-icon-loading"
      >
        <el-table-column label="付款项" prop="payType"></el-table-column>
        <el-table-column prop="paymentForGoods" label="总金额">
          <template slot-scope="scope">{{scope.row.amount|priceFilterNum}}</template>
        </el-table-column>
        <el-table-column prop="guaranteeAmount" label="已收账款">
          <template slot-scope="scope">{{scope.row.amountReceived|priceFilterNum}}</template>
        </el-table-column>
      </el-table>
      <div>说明：{{type===1?'划拨后立即扣除期初应收款相应金额':type===2?'划拨金额优先划拨预付款':'划拨后立即扣除工单应收账款相应金额'}}</div>
    </div>
    <span slot="footer" class="dialog-center">
      <el-button @click="onTransfer" type="primary">划拨</el-button>
      <el-button @click="disableDialog = false">取消</el-button>
    </span>
    <!-------------- 更新模板客户提示 -------------->
    <again-hint-dialog
      :content="content"
      title="划拨确认"
      @onUpdataState="onUpdataState"
      ref="againHintRefs"
    ></again-hint-dialog>
  </el-dialog>
</template>
<script>
import OpenOrClose from '@/components/OpenOrClose/index'
import { updateInitalByCusId } from '@/api/customer/customerManage'
import { updateContractBaseByOcbIdCusId, orderAllocation } from '@/api/sell/sellManage'
import { priceFilterNum } from '@/util/filterCommon.js'
export default {
  components: {
    'again-hint-dialog': OpenOrClose
  },
  data() {
    return {
      disableDialog: false,
      type: 0, // 1 客户划拨 2 合同  3 工单
      params: {},
      amount: undefined, // 划拨金额
      loadingTable: false,
      content: '',
      initalBalanceVal: 0 // 最大值
    }
  },
  methods: {
    // 弹窗初始化
    onInitial(val, type) {
      this.type = type
      this.amount = undefined
      this.disableDialog = true
      if (type === 1) {
        this.initalBalanceVal = val
      } else if (type === 2) {
        this.initalBalanceVal = val.accountsCollect
        this.params = val
      } else {
        this.initalBalanceVal = val.amountReceivable
        this.params = val
      }
    },
    // 划拨
    onTransfer() {
      if (this.amount) {
        if (this.amount > this.initalBalanceVal) {
          const str =
            this.type === 1
              ? '该合同的期初应收款为'
              : this.type === 2
                ? '该合同的应收账款为'
                : '该工单的应收账款为' + this.initalBalanceVal + '！'
          this.$message.error(str)
        } else {
          this.content = `本次划拨￥${priceFilterNum(this.amount)}，划拨后不得撤回，请确认划拨`
          this.disableDialog = false
          this.$refs.againHintRefs.onInitial()
        }
      } else {
        this.$message.error('请填写划拨金额')
      }
    },
    // 设置头部背景色
    tableHeader({ rowIndex }) {
      return this.$tableHeader(rowIndex)
    },
    // 确认划拨
    onUpdataState() {
      if (this.type === 1) {
        // 客户划拨
        updateInitalByCusId({
          initalBalance: this.amount,
          cusId: this.$route.query.id
        }).then((res) => {
          if (res.data.code === 200) {
            this.$message.success('划拨成功！')
            this.$emit('onRefresh', 1)
          } else {
            this.$message.error(res.data.msg)
          }
        })
      } else if (this.type === 2) {
        // 销售合同划拨
        this.params.initalBalance = this.amount
        updateContractBaseByOcbIdCusId(this.params.contractId, this.params).then((res) => {
          if (res.data.code === 200) {
            this.$message.success('划拨成功！')
            this.$emit('onRefresh', 2)
          } else {
            this.$message.error(res.data.msg)
          }
        })
      } else {
        const obj = {
          orderAllocationMoney: this.amount,
          orderContractSalereturnOrder: this.params
        }

        orderAllocation(obj).then((res) => {
          if (res.data.code === 200) {
            this.$message.success('划拨成功！')
            this.$emit('onRefresh', 2)
          } else {
            this.$message.error(res.data.msg)
          }
        })
      }
    }
  }
}
</script>
